export const TRANSLATION_KEYS = {
  widgetTitle: 'jbp-thing-to-improve',

  attachments: 'jbp-key-initiatives-attachments',

  keyInitiativesFormat: 'jbp-key-initiatives-format',

  keyInitiativeEditor: {
    isNotApplicable: 'jbp-key-initiative-editor-not-aplicable',
    isApplicable: 'jbp-key-initiative-editor-aplicable',
    name: 'jbp-key-initiatives-name',
    keyInitiativeTitle: 'jbp-key-initiatives-create-key-initiative-title',
    parentKeyInitiativeTitle: 'jbp-key-initiatives-edit-parent-key-initiative-title',
    focusStatus: 'jbp-key-initiatives-focus-status',
    productLinesSelect: 'jbp-key-initiatives-products',
    categoryDropdown: 'jbp-key-initiatives-category',
    widgetViewLabel: 'jbp-key-initiatives-widget-view-label',
    copyAsNewButton: 'jbp-key-initiatives-editor-copy-as-new-button',

    businessUnitAndFocusFieldGroup: {
      groupHint: 'jbp-key-initiatives-business-unit-and-focus-hint-label',
      businessUnit: 'jbp-key-initiatives-business-unit',
      focusArea: 'jbp-key-initiatives-focus-area',
      description: 'jbp-key-initiatives-description',
      currentProgress: 'jbp-key-initiatives-current-progress',
      followUp: 'jbp-key-initiatives-follow-up',

      groupLabel: 'jbp-key-initiatives-business-unit-and-focus-label',
      groupDesc: 'jbp-key-initiatives-business-unit-and-focus-description',

      unitLabel: 'jbp-key-initiatives-business-unit-label',
      unitPlaceholder: 'jbp-key-initiatives-business-unit-placeholder',
      focusLabel: 'jbp-key-initiatives-business-focus-label',
      focusPlaceholde: 'jbp-key-initiatives-business-focus-placeholder',
    },
    descriptionQuality: {
      guidance: 'jbp-key-initiatives-description-quality-guidance',
      example: 'jbp-key-initiatives-description-quality-example',
      exampleTooltip: 'jbp-key-initiatives-description-quality-example-tooltip',
      score: 'jbp-key-initiatives-description-quality-score',
      suggestions: 'jbp-key-initiatives-description-quality-suggestions',
      validation: 'jbp-key-initiatives-description-quality-validation',
    },
    keyInitiativeAndPeriodFieldGroup: {
      groupHint: 'jbp-key-initiatives-objective-and-period-hint-label',

      strategicInitiativeLabel: 'jbp-key-initiatives-strategic-initiative-label',
      strategicInitiativePlaceholder: 'jbp-key-initiatives-strategic-initiative-placeholder',
      periodLabel: 'jbp-key-initiatives-period-label',
      initiativeNameLabel: 'jbp-key-initiatives-initiative-name-label',
      initiativeNamePlaceholder: 'jbp-key-initiatives-initiative-name-placeholder',
      descriptionLabel: 'jbp-key-initiatives-description-label',
      descriptionPlaceholder: 'jbp-key-initiatives-description-placeholder',
      partnerContactLabel: 'jbp-key-initiatives-partner-contact-label',
      partnerContactPlaceholder: 'jbp-key-initiatives-partner-contact-placeholder',
      secondaryIniativeLabel: 'jbp-key-initiatives-secondary-iniative-label',
      secondaryIniativePlaceholder: 'jbp-key-initiatives-secondary-iniative-placeholder',

      strategicInitiativeDesc: 'jbp-key-initiatives-strategic-initiative-description',
      periodDesc: 'jbp-key-initiatives-period-description',
      initiativeNameDesc: 'jbp-key-initiatives-initiative-name-description',
      descriptionDesc: 'jbp-key-initiatives-description-description',
      partnerContactDesc: 'jbp-key-initiatives-partner-contact-description',
      secondaryIniativeDesc: 'jbp-key-initiatives-secondary-iniative-description',

      development: 'jbp-key-initiatives-development',
      keyObjectiveTags: 'jbp-key-initiatives-key-objective-tags',

      activityType: 'jbp-key-initiatives-activity-type',
      period: 'jbp-key-initiatives-period',
      owner: 'jbp-key-initiatives-owner',
    },
    checkboxesFieldGroup: {
      groupHint: 'jbp-key-initiatives-checkboxes-hint-label',
      shouldAddToBridgesHint: 'jbp-key-initiatives-should-add-to-bridges-hint-label',
      shouldAddToBridges: 'jbp-key-initiatives-should-add-to-bridges',
      dataInsightRelatedHint: 'jbp-key-initiatives-data-insight-related-hint-label',
      dataInsightRelated: 'jbp-key-initiatives-data-insight-related',

      shouldAddToBridgesLabel: 'jbp-key-initiatives-should-add-to-bridges-label',
      shouldAddToBridgesDesc: 'jbp-key-initiatives-should-add-to-bridges-description',

      dataInsightRelatedLabel: 'jbp-key-initiatives-data-insight-related-label',
      dataInsightRelatedDesc: 'jbp-key-initiatives-data-insight-related-description',
    },
    goalFieldGroup: {
      groupHint: 'jbp-key-initiatives-goal-hint-label',
      warning: 'jbp-key-initiatives-goal-warning-label',
      lowWarning: 'jbp-key-initiatives-goal-low-warning-label',
      emptyPlan: 'jbp-key-initiatives-goal-empty-plan-label',
      error: 'jbp-key-initiatives-goal-error-label',
      justification: 'jbp-key-initiatives-goal-justification-label',

      groupLabel: 'jbp-key-initiatives-goal-group-label',
      groupDesc: 'jbp-key-initiatives-goal-group-description',

      goalLabel: 'jbp-key-initiatives-goal-label',
      goalLabelWithPlan: 'jbp-key-initiatives-goal-label-with-plan',
      goalDesc: 'jbp-key-initiatives-goal-description',
      goalPlaceholder: 'jbp-key-initiatives-goal-placeholder',

      runRateMode: 'jbp-key-initiatives-goal-mode-run-rate',
      incrementalMode: 'jbp-key-initiatives-goal-mode-incremental',
      noSalesTargetMode: 'jbp-key-initiatives-goal-mode-no-sales-target',

      incrementalLabel: 'jbp-key-initiatives-incremental-label',
      incrementalDesc: 'jbp-key-initiatives-incremental-description',
      incrementalPlaceholder: 'jbp-key-initiatives-incremental-placeholder',
    },
    investmentFieldGroup: {
      groupHint: 'jbp-key-initiatives-investment-hint-label',
      investmentSum: 'jbp-key-initiatives-investment-sum',
      investmentSource: 'jbp-key-initiatives-investment-source',
      expectedOutcome: 'jbp-key-initiatives-expected-outcome',
      expectedOutcomeWithoutPlan: 'jbp-key-initiatives-expected-outcome-without-plan',
      expectedOutcomeIncremental: 'jbp-key-initiatives-expected-outcome-incremental',
      expectedOutcomeIncrementalWithoutPlan:
        'jbp-key-initiatives-expected-outcome-incremental-without-plan',
      expectedOutcomeNoSalesTarget: 'jbp-key-initiatives-expected-outcome-no-sales-target',

      investmentSumLabel: 'jbp-key-initiatives-investment-sum-label',
      investmentSourceLabel: 'jbp-key-initiatives-investment-source-label',
      investmentSumPlaceholder: 'jbp-key-initiatives-investment-sum-placeholder',
      investmentSumPositiveRequired: 'jbp-key-initiatives-investment-sum-positive-required',
      investmentSourcePlaceholder: 'jbp-key-initiatives-investment-source-placeholder',
    },
    outcomeFieldGroup: {
      funnelSize: 'jbp-key-initiatives-outcome-funnel-size',
      leads: 'jbp-key-initiatives-outcome-leads',
      conversionRate: 'jbp-key-initiatives-outcome-conversion-rate',
      attendance: 'jbp-key-initiatives-outcome-attendance',
      estimateSales: 'jbp-key-initiatives-outcome-estimate-sales',
      outcomeValueType: 'jbp-key-initiatives-outcome-value-type',
      otherInfo: 'jbp-key-initiatives-outcome-other-info',
      otherInfoPlaceholder: 'jbp-key-initiatives-outcome-other-info-placeholder',
      itemName: 'jbp-key-initiatives-outcome-item-name',
      itemValueType: 'jbp-key-initiatives-outcome-item-value-type',
      itemValue: 'jbp-key-initiatives-outcome-item-value',
      itemNamePlaceholder: 'jbp-key-initiatives-outcome-item-name-placeholder',
      itemValuePlaceholder: 'jbp-key-initiatives-outcome-item-value-placeholder',
      addItem: 'jbp-key-initiatives-outcome-add-item',
      removeItem: 'jbp-key-initiatives-outcome-remove-item',
      valueTypes: {
        financial: 'jbp-key-initiatives-outcome-type-financial',
        number: 'jbp-key-initiatives-outcome-type-number',
        percentage: 'jbp-key-initiatives-outcome-type-percentage',
        freeText: 'jbp-key-initiatives-outcome-type-free-text',
      },
    },
    capabilitiesPillarInitiativeFieldGroup: {
      groupHint: 'jbp-key-initiatives-capabilities-pillar-hint-label',
      goalDescription: 'jbp-key-initiatives-goal-description',
      proofOfExecution: 'jbp-key-initiatives-proof-of-execution',
      isAchieved: 'jbp-key-initiatives-is-achieved-label',
    },
    practiceDevelopment: {
      description: 'jbp-key-initiatives-practice-development-description',
      placeholder: 'jbp-key-initiatives-practice-development-placeholder',

      practiceBuilderLabel: 'jbp-key-initiatives-practice-development-practice-builder-label',
      practiceBuilderPlaceholder:
        'jbp-key-initiatives-practice-development-practice-builder-placeholder',
    },
    progressView: {
      groupHint: 'jbp-key-initiatives-progress-view-hint-label',

      statusLabel: 'jbp-key-initiatives-progress-view-status-label',
      statusDesc: 'jbp-key-initiatives-progress-view-status-description',

      selectorPlaceholder: 'jbp-key-initiatives-progress-view-selector-placeholder',

      dropdownOkButton: 'jbp-key-initiatives-progress-view-ok-button',

      currentProgressLabel: 'jbp-key-initiatives-progress-view-current-progress-label',
      currentProgressDesc: 'jbp-key-initiatives-progress-view-current-progress-description',
      currentProgressPlaceholder: 'jbp-key-initiatives-current-progress-placeholder',

      followUpLabel: 'jbp-key-initiatives-progress-view-follow-up-label',
      followUpDesc: 'jbp-key-initiatives-progress-view-follow-up-description',
      followUpPlaceholder: 'jbp-key-initiatives-follow-up-placeholder',
    },
  },

  gpKeyInitiativeEditor: {
    geo: 'jbp-key-initiatives--gp-editor--geo',
    affectToIncludingPartners: 'jbp-key-initiatives--gp-editor--affect-to-including-partners',
  },
  addNewButton: 'jbp-key-initiatives-add-new',
  initiativesWarning: {
    initiativesWarningCompletedMessage: 'jbp-key-initiatives-warning-completed-message',
  },
  initiativesMessage: {
    initiativesCompletedMessage: 'jbp-key-initiatives-completed-message',
  },
  switchers: {
    growthPlaySwithcer: 'jbp-key-initiatives-growth-play-switcher',
    growthPlayTooltip: 'jbp-key-initiatives-growth-play-tooltip',
    amplifyImpactSwithcer: 'key-initiatives-ai-switcher',
    amplifyImpactTooltip: 'key-initiatives-ai-tooltip',
  },
  filters: {
    focusArea: 'jbp-key-initiatives-focus-area-filter-label',
    keyObjective: 'jbp-key-initiatives-key-objective-filter-label',
    showAssignedInitiatives: 'jbp-key-initiatives-lp-show-assigned-initiatives',
    showAffectedInitiatives: 'jbp-key-initiatives-gp-show-assigned-initiatives',
  },

  tableColumns: {
    businessUnit: 'jbp-key-initiatives-business-unit',
    focusArea: 'jbp-key-initiatives-focus-area',
    name: 'jbp-key-initiatives-name',
    description: 'jbp-key-initiatives-description',
    period: 'jbp-key-initiatives-period',
    owner: 'jbp-key-initiatives-owner',
    bridges: 'jbp-key-initiatives-bridges-column-title',
    keyObjectiveTags: 'jbp-key-initiatives-key-objective-tags-column-title',
    goal: 'jbp-key-initiatives-goal',
    isAchieved: 'jbp-key-initiatives-is-achieved',
    investmentNeeds: 'jbp-key-initiatives-investment-needs',
    investmentSum: 'jbp-key-initiatives-investment-sum',
    investmentSource: 'jbp-key-initiatives-investment-source',
    focusStatus: 'jbp-key-initiatives-focus-status',
    category: 'jbp-actionplans-strategies-goals-category',
    currentProgress: 'jbp-key-initiatives--table-column--current-progress',
    followUp: 'jbp-key-initiatives--table-column--follow-up',
  },

  gpTableColumns: {
    goal: 'jbp-key-initiatives--gp-table-goal',
    rollupGoal: 'jbp-key-initiatives--gp-table-rollup-goal',
    partnersImpact: 'jbp-key-initiatives--gp-table-partners-impact',
    rollupPartnersImpactApplicableCount:
      'jbp-key-initiatives--gp-table-partners-impact-applicable-count',
    rollupPartnersImpactNotApplicableCount:
      'jbp-key-initiatives--gp-table-partners-impact-not-applicable-count',
    rollupPartnersCount: 'jbp-key-initiatives--gp-table-rollup-partners-count',
    rollupPartnersPendingCount: 'jbp-key-initiatives--gp-table-rollup-partners-pending-count',
    gpHpInvestmentSum: 'jbp-key-initiatives--gp-table-hp-investment-sum',
  },

  copyFromPreviousYear: {
    buttonTitle: 'jbp-key-initiatives-copy-from-prev-year',
    confirm: 'jbp-key-initiatives-copy-from-prev-year-confirm',
    submit: 'jbp-key-initiatives-copy-from-prev-year-submit',
  },

  checkboxRollup: 'jbp-key-initiatives-check-box-rollup',

  rollUpTableColumns: {
    geo: 'jbp-key-initiatives--table-columns--geo',
    initiatives: 'jbp-key-initiatives--table-column--initiatives',
    keyObjectives: 'jbp-key-initiatives--table-column--key-objectives',
    finGoal: 'jbp-key-initiatives--table-column--fin-goal',
    funds: 'jbp-key-initiatives--table-column--funds',
    bridges: 'jbp-key-initiatives--table-column--bridges',
    status: 'jbp-key-initiatives--table-column--status',
    focusArea: 'jbp-key-initiatives--table-column--focus-area',
    bu: 'jbp-key-initiatives--table-column--bu',
    owner: 'jbp-key-initiatives--table-column--owner',
    period: 'jbp-key-initiatives--table-column--period',
    description: 'jbp-key-initiatives--table-column--description',
  },

  rollUpFilters: {
    focusArea: 'jbp-key-initiatives--roll-up-filters--focus-area',
    keyObjectives: 'jbp-key-initiatives--roll-up-filters--key-objectives',
    businessUnits: 'jbp-key-initiatives--roll-up-filters--business-units',
    apply: 'jbp-key-initiatives--roll-up-filters--apply',
    cancel: 'jbp-key-initiatives--roll-up-filters--cancel',
  },

  affectedLPModal: {
    headerDelete: 'jbp-key-initiatives--affected-lp-modal-header-delete',
    headerUpdate: 'jbp-key-initiatives--affected-lp-modal-header',
    textDelete: 'jbp-key-initiatives--affected-lp-modal-text-delete',
    textUpdate: 'jbp-key-initiatives--affected-lp-modal-text',
    agree: 'jbp-key-initiatives--affected-lp-modal-agree',
    cancel: 'jbp-key-initiatives--affected-lp-modal-cancel',
  },
}
